// Dependencies
import React from 'react';

// Utils
import { containsHtmlTags } from '../utils/data';


const HtmlText = ({ text }) => (
  containsHtmlTags(text)
    ? <span dangerouslySetInnerHTML={{ __html: text }} />
    : <span>{text}</span>
);

export default HtmlText;
